import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M2.75 6.5q.75.016 1.242.508T4.5 8.25q-.015.75-.508 1.242Q3.5 9.984 2.75 10 2 9.985 1.508 9.492 1.016 9 1 8.25q.016-.75.508-1.242T2.75 6.5M8 6.5q.75.016 1.242.508T9.75 8.25q-.015.75-.508 1.242Q8.75 9.984 8 10q-.75-.015-1.242-.508Q6.266 9 6.25 8.25q.016-.75.508-1.242T8 6.5m5.25 0q.75.016 1.242.508T15 8.25q-.015.75-.508 1.242Q14 9.984 13.25 10q-.75-.015-1.242-.508Q11.516 9 11.5 8.25q.015-.75.508-1.242.492-.492 1.242-.508"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })